import { OfferingCircularsPage } from 'types/sanity/offering-circulars';
import { OfferingCircularsPageQuery } from './queries/offering-circulars-page';
import { SanityGraphQLResponse } from 'types/sanity';
import { useQuery } from 'villus';
import { villusClient } from '@utils/villus';

type SanityOfferingCircularsPageResponse = SanityGraphQLResponse<OfferingCircularsPage, 'allOfferingCirculars'>;

export async function getOfferingCircularsPage(): Promise<OfferingCircularsPage | null> {
	const { data } = await useQuery<SanityOfferingCircularsPageResponse>({
		client: villusClient,
		query: OfferingCircularsPageQuery,
		tags: ['offering_circulars_page']
	}).execute();

	return data?.allOfferingCirculars[0] ?? null;
}
